module.exports = __webpack_public_path__ + "static/media/returns_no_zoom.81ef1a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/returns_no_zoom.png
// module id = 102
// module chunks = 0